var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto overflow-hidden layout"},[_c('AppBar'),_c('Sidebar',{staticClass:"sidebar"}),_c('v-main',{staticClass:"content pt-0",staticStyle:{"padding-left":"256px"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }